
import React from 'react';
import CheckedIcon from 'material-ui/svg-icons/navigation/check';
import UnCheckedIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';

export const selectFieldDefaultProps = {
  anchorOrigin: { vertical: 'top', horizontal: 'left' },
  autocompleteFilter: (searchText, text) => {
    if (!text || (typeof text !== 'string' && typeof text !== 'number')) {
      return false;
    }
    if (typeof searchText !== 'string' && typeof searchText !== 'number') {
      return false;
    }
    return (text + '').toLowerCase().includes(searchText.toLowerCase());
  },
  autocompleteStyle: {},
  canAutoPosition: true,
  checkPosition: '',
  checkedIcon: <CheckedIcon style={{ top: 'calc(50% - 12px)' }} />,
  children: [],
  disabled: false,
  elementHeight: 36,
  hintTextAutocomplete: 'Type something',
  keepSearchOnSelect: false,
  menuCloseButton: null,
  multiple: false,
  nb2show: 5,
  noMatchFound: 'No match found',
  noMatchFoundStyle: {},
  onAutoCompleteTyping: () => {},
  onChange: () => {},
  onMenuOpen: () => {},
  onSelect: () => {},
  openImmediately: false,
  showAutocompleteThreshold: 10,
  unCheckedIcon: <UnCheckedIcon style={{ top: 'calc(50% - 12px)' }} />,
  value: null,
};
export const selectionsPresenterDefaultProps = {
  errorStyle: {},
  errorText: '',
  hintText: 'Click me',
  selectionsRenderer: (values, hintText) => {
    if (!values) {
      return hintText;
    }
    const { value, label } = values;
    if (Array.isArray(values)) {
      return values.length ? values.map((selectedValue) => {
        return selectedValue.label || selectedValue.value;
      }).join(', ') : hintText;
    } else if (label || value) {
      return label || value;
    }
    return hintText;
  },
  underlineErrorStyle: {},
};

export const floatingLabelDefaultProps = {
  shrink: false,
};



// WEBPACK FOOTER //
// ./src/common/components/superselectfield/defaultProps.js